import {CommandController} from "./../commanding/CommandController";
import {BasicController} from "./controller/BasicController";
import {BasicInitServerCommands} from "./controller/clientCommands/BasicInitServerCommands";
import {BasicExtensionResponseCommand} from "./controller/clientCommands/BasicExtensionResponseCommand";
import {BasicJoinedRoomCommand} from "./controller/clientCommands/BasicJoinedRoomCommand";
import {BasicConnectionFailedCommand} from "./controller/clientCommands/BasicConnectionFailedCommand";
import {BasicPrepareReconnectCommand} from "./controller/clientCommands/BasicPrepareReconnectCommand";
import {BasicDestroyGameCommand} from "./controller/clientCommands/BasicDestroyGameCommand";
import {IEnvironmentGlobals} from "./IEnvironmentGlobals";
import {KeyboardEventDispatcher, MouseEventDispatcher} from "@goodgamestudios/createjs-utilities";
import {BasicConnectClientCommand} from "./controller/clientCommands/BasicConnectClientCommand";
import {BasicConnectToInstanceVOCommand} from "./controller/clientCommands/BasicConnectToInstanceVOCommand";
import {EnvGlobalsHandler} from "./EnvGlobalsHandler";
import {BasicModel} from "./model/BasicModel";
import {BasicCheckMaintenanceCommand} from "./controller/clientCommands/BasicCheckMaintenanceCommand";
import {BasicLoginCommand} from "./controller/clientCommands/BasicLoginCommand";
import {ChooseLoginMethodCommand} from "./controller/clientCommands/ChooseLoginMethodCommand";
import {BasicInitalizeControllerCommand} from "./controller/clientCommands/BasicInitalizeControllerCommand";
import {BasicChangeCountryCommand} from "./controller/clientCommands/BasicChangeCountryCommand";
import {Signal} from "signals.js";
import {BasicBackgroundComponent} from "./view/BasicBackgroundComponent";
import {debug} from "../logging/debug";
import {ClientFunnelTrackingController} from "../tracking/clientFunnel/ClientFunnelTrackingController";
import Ticker = createjs.Ticker;
import Container = createjs.Container;
import Stage = createjs.Stage;
import Event = createjs.Event;
import { BasicConstants } from "./constants/BasicConstants";

/**
 * BasicGame
 */
export class BasicGame extends Container {

    protected initialized: Signal;
    protected preloaderView: BasicBackgroundComponent;

    constructor(preloaderView: BasicBackgroundComponent) {
        super();
        this.preloaderView = preloaderView;
        this.initialized = new Signal();
        this.initialized.addOnce(this.bindFunction(this.onGameInitialized));
    }

    private onGameInitialized(): void {
        debug("Game initialization complete.")
        // Connect to server
        CommandController.instance.executeCommand(BasicController.COMMAND_CONNECT_TO_INSTANCEVO, BasicModel.instanceProxy.selectedInstanceVO);
    }

    /**
     * is executed when this game added to stage
     * initialize gameproperties and tracked Pageview for analytics
     */
    //TODO @HTML5 to implement this later
    public onAddedToStage(e: Event = null): void {

        KeyboardEventDispatcher.init(this.stage);
        MouseEventDispatcher.init();
        ClientFunnelTrackingController.getInstance().stage = this.stage;

        let game: BasicGame = this;
        window.addEventListener('resize', function () {
            game.onWindowResized();
        }, false);

        //   if (this._canvas) {
        this.initialize();
        //}
    }

    private initialize(): void {
        // update the game scale
        this.onWindowResized();

        // Registers the "tick" event listener.
        this.initializeTicker();

        // Show canvas of cache game
        //   this._canvas.style.display = "";

        this.registerCommands();

        // TODO: Check when this method should be called
        this.initializeGame();
    }

    protected addGameSpecificEnvironments(): void {
        // for Override
    }


    protected get customEnvironments(): any[] {
        return [];
    }

    private onWindowResized(): void {
        if (this.stage) {
            (this.stage.canvas as any).width = window.innerWidth;
            (this.stage.canvas as any).height = window.innerHeight;
        }
    }

    private initializeTicker(): void {
        // Registers the "tick" event listener.
        Ticker.framerate = BasicConstants.TARGET_FRAMERATE;
        Ticker.addEventListener("tick", this.onTick.bind(this));
    }

    protected onTick(props?: Object): void {
        if (!Ticker.paused) {
            this.stage.update();
        }
    }

    protected registerCommands(): void {
    }


    protected initPreClientCommands(): void {
        // CommandController.instance.registerCommand(BasicController.COMMAND_FACEBOOK_INITIALIZE, BasicInitializeFacebookConnectCommand);
    }


    protected initializeGame(): void {
    }

    protected get env(): IEnvironmentGlobals {
        return EnvGlobalsHandler.globals;
    }
}
